import { render, staticRenderFns } from "./VueSwiperProducts.vue?vue&type=template&id=223befbc"
import script from "./VueSwiperProducts.vue?vue&type=script&lang=js"
export * from "./VueSwiperProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223befbc')) {
      api.createRecord('223befbc', component.options)
    } else {
      api.reload('223befbc', component.options)
    }
    module.hot.accept("./VueSwiperProducts.vue?vue&type=template&id=223befbc", function () {
      api.rerender('223befbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueSwiperProducts.vue"
export default component.exports